<template>
  <div class="IpListpage">
    <div class="Ipname">
      <div class>
        <span>{{ userinfo.Name }}</span>
        <span>{{ userinfo.CardNumber }}</span>
        <span class="cor" @click="swith()">切换就诊人</span>
        <span class="needle">></span>
      </div>
    </div>
    <div class="Iptime">
      <span>入院时间：</span>
      <span class="sel" @click="checkPickerOption">{{ timeType }}</span>
    </div>
    <div>
      <div
        v-for="(item,index) in ipListInfo"
        :key="index"
        class="Ipdeteil"
        @click="IpPaymentRecord(item.IpNo)"
        v-show="isShow"
      >
        <div>
          <p class="pensontit">
            <img src="../../assets/images/penson.png" alt class="pensonpic" />
            <span>{{item.PatName}}</span>
            <span>（{{item.IpNo}}）</span>
            <span class="fontred">{{item.IpPaymentStateName}}</span>
            <span class="smallicon">></span>
          </p>
          <div class="pd20">
            <p>
              <span>入院诊断：</span>
              <span>{{item.IpDiagnosis}}</span>
            </p>
            <p>
              <span>入院科室：</span>
              <span>{{item.IpDptName}}</span>
            </p>
            <p>
              <span>入院日期:</span>
              <span class="mr18">{{item.IpDate}}</span>
            </p>
            <div class="pd20right cor">{{item.StateName}}</div>
          </div>
        </div>
      </div>
      <div class="noDate" v-show="!isShow">
        <div v-show="true" class="nolist">
          <!-- 无数据显示 -->
          <img src="../../assets/images/searchbg.png" alt class="searchpic" />
          <p class="center">暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetVisits, GetIpListByPatID, GetItem } from "@/services/getData.js";
import weui from "weui.js";
import moment from "moment";
export default {
  name: "IpList",
  data() {
    return {
      timeType: "七天内",
      userinfo: {},
      isShow: true,
      ipListInfo: [],
      moment: moment
    };
  },
  created: function() {
    this.GetIpListByPatID();
    this.userinfo = this.$store.state.userInfo;
  },
  methods: {
    checkPickerOption: function() {
      var _that = this;
      weui.picker(
        [
          {
            label: "七天内",
            value: 0
          },
          {
            label: "三个月内",
            value: 1
          },
          {
            label: "半年内",
            value: 2
          },
          {
            label: "不限时间",
            value: 3
          }
        ],
        {
          onChange: function(result) {},
          onConfirm: function(result) {
            _that.timeType = result["0"]["label"];

            _that.GetIpListByPatID(result["0"]["value"]);
          }
        }
      );
    },
    swith() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    IpPaymentRecord(guid) {
      this.$router.push({
        path: "/IpPayment/IpPaymentRecord",
        query: { ipNo: guid }
      });
    },
    GetIpListByPatID: function(selectType) {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });

      GetIpListByPatID(GetItem("patid"), selectType).then(response => {
        console.log(response);
        loading.hide();
        var _this = this;
        if (response.data.Result) {
          this.ipListInfo = response.data.Extend;
        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: response.data.Content,
            buttons: [
              {
                label: "确定",
                type: "primary",
                onClick: function() {
                  // _this.$router.back(-1);
                }
              }
            ]
          });
        }
      });
    }
  }
};
</script>
<style>
.IpListpage {
  width: 100%;
  height: 100%;
  position: relative;
}

.IpListpage .Ipname {
  width: 100%;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  padding: 0 0.2rem;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.8rem;
  box-sizing: border-box;
}

.Ipname > div {
  position: relative;
}

.IpListpage .Ipname .cor {
  color: #feff82 !important;
  float: right;
  margin-right: 0.4rem;
}

.IpListpage .needle {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
  top: -0.02rem;
}

select {
  outline: none;
  border: 0;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  width: auto;
  padding: 0 0.3rem;
  appearance: none;
  -webkit-appearance: none;
}

.IpListpage .Iptime {
  padding: 0.2rem;
  height: auto;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.IpListpage .Ipdeteil {
  background: white;
  padding: 0 0.2rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.36rem;
  margin-bottom: 0.2rem;
}

.IpListpage .Ipdeteil .pensontit {
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  position: relative;
  box-sizing: border-box;
  padding-top: 0.2rem;
  padding-bottom: 0.18re;
  padding-bottom: 0.14rem;
}

.IpListpage .Ipdeteil .pensontit .pensonpic {
  width: 0.22rem;
  height: 0.28rem;
  display: inline-block;
  vertical-align: text-top;
}

.IpListpage .Ipdeteil .pensontit .fontblue {
  color: rgba(21, 146, 228, 1) !important;
  float: right;
  margin-right: 0.4rem;
}

.IpListpage .Ipdeteil .pensontit .fontred {
  color: #ff0000 !important;
  float: right;
  margin-right: 0.4rem;
}

.IpListpage .Ipdeteil .pensontit .smallicon {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
}

.IpListpage .Ipdeteil .pd20 {
  padding: 0.2rem 0;
  box-sizing: border-box;
  position: relative;
}
.IpListpage .Ipdeteil .pd20 .pd20right {
  position: absolute;
  top: calc(50% - 0.2rem);
  right: 0.2rem;
  color: #999999;
}
.IpListpage .Ipdeteil .pd20 .pd20right.cor {
  color: #579c53;
}
.mr18 {
  margin-left: 0.18rem;
}
.IpListpage .sel {
  width: 1.5rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  line-height: 0.4rem;
  /* text-align: center; */
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
.IpListpage .sel::after {
  position: absolute;
  display: inline-block;
  content: "";
  right: 0.18rem;
  width: 0;
  height: 0rem;
  border-width: 0.11rem 0.07rem;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
  top: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/IpPayment/IpList.vue